const TURNSTILE_FLOW_STORAGE_KEY = 'alu_turnstile_action_tokens';
const TURNSTILE_TOKEN_TTL_MS = 5 * 60 * 1000;

const readStore = () => {
  if (typeof window === 'undefined') return {};
  try {
    const raw = sessionStorage.getItem(TURNSTILE_FLOW_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

const writeStore = (nextStore) => {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(TURNSTILE_FLOW_STORAGE_KEY, JSON.stringify(nextStore));
  } catch {
    // Ignore storage write errors.
  }
};

const pruneExpired = (store, nowMs = Date.now()) => {
  const next = { ...store };
  Object.entries(next).forEach(([action, entry]) => {
    const issuedAt = Number(entry?.issuedAt || 0);
    const token = typeof entry?.token === 'string' ? entry.token : '';
    if (!token || !Number.isFinite(issuedAt) || issuedAt + TURNSTILE_TOKEN_TTL_MS <= nowMs) {
      delete next[action];
    }
  });
  return next;
};

export const saveTurnstileTokenForAction = (action, token) => {
  const normalizedAction = String(action || '').trim();
  const normalizedToken = String(token || '').trim();
  if (!normalizedAction || !normalizedToken) return;

  const pruned = pruneExpired(readStore());
  pruned[normalizedAction] = {
    token: normalizedToken,
    issuedAt: Date.now(),
  };
  writeStore(pruned);
};

export const consumeTurnstileTokenForAction = (action) => {
  const normalizedAction = String(action || '').trim();
  if (!normalizedAction) return '';

  const pruned = pruneExpired(readStore());
  const token = String(pruned?.[normalizedAction]?.token || '').trim();
  if (token) {
    delete pruned[normalizedAction];
    writeStore(pruned);
    return token;
  }

  writeStore(pruned);
  return '';
};
